import { AuthService } from 'shared/mechanics/auth';
import { SubscriptionInvoiceRef, SubscriptionPlanBackend, YouKassaPaymentBackend } from './subscription.model';

const apiBaseUrl = process.env.REACT_APP_INTEGRATION_SUBSCRIPTION_URIBASE!;

export interface ISubscriptionService {
	createYouKassaPaymnent(invoiceId: string): Promise<YouKassaPaymentBackend>;

	plans(): Promise<SubscriptionPlanBackend[]>;

	createInvoice(subscriptionPlanSystemName: string): Promise<SubscriptionInvoiceRef>;
}

export class SubscriptionServiceImpl implements ISubscriptionService {
	async plans(): Promise<SubscriptionPlanBackend[]> {
		const response = await fetch(`${apiBaseUrl}/plans`);
		const plans = await response.json();
		return plans;
	}

	async createInvoice(subscriptionPlanSystemName: string): Promise<SubscriptionInvoiceRef> {
		const userAuthenticationToken = AuthService.resolveUserAuthenticationToken();
		if (userAuthenticationToken == null)
			throw "method require authenticated user";

		const request = {
			subscriptionPlanSystemName: subscriptionPlanSystemName,
			userAuthenticationToken: userAuthenticationToken
		};
		const requestOptions: RequestInit = {
			method: 'POST',
			body: JSON.stringify(request),
			headers: { 'content-type': 'application/json' }
		};

		const response = await fetch(`${apiBaseUrl}/invoice/create`, requestOptions);
		const invoice = await response.json();
		return invoice;
	}

	async createYouKassaPaymnent(invoiceId: string): Promise<YouKassaPaymentBackend> {
		const request = { invoiceId: invoiceId };
		const requestOptions: RequestInit = {
			method: 'POST',
			body: JSON.stringify(request),
			headers: { 'content-type': 'application/json' }
		};

		const response = await fetch(`${apiBaseUrl}/payment/create/youkassa`, requestOptions);
		const responseData = await response.json();
		return responseData;
	}
}